export const assetClassConstants = {
  API_INSERT: '/api/class/insert',
  API_UPDATE: '/api/class/update',
  API_DELETE: '/api/class/delete',
  API_GET: '/api/class/',
  API_GETALL: '/api/class/getall',

  INSERT_REQUEST: 'ASSET_CLASS_INSERT_REQUEST',
  INSERT_SUCCESS: 'ASSET_CLASS_INSERT_SUCCESS',
  INSERT_FAILURE: 'ASSET_CLASS_INSERT_FAILURE',

  UPDATE_REQUEST: 'ASSET_CLASS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'ASSET_CLASS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'ASSET_CLASS_UPDATE_FAILURE',

  DELETE_REQUEST: 'ASSET_CLASS_DELETE_REQUEST',
  DELETE_SUCCESS: 'ASSET_CLASS_DELETE_SUCCESS',
  DELETE_FAILURE: 'ASSET_CLASS_DELETE_FAILURE',

  GET_REQUEST: 'ASSET_CLASS_GET_REQUEST',
  GET_SUCCESS: 'ASSET_CLASS_GET_SUCCESS',
  GET_FAILURE: 'ASSET_CLASS_GET_FAILURE',

  GETALL_REQUEST: 'ASSET_CLASS_GETALL_REQUEST',
  GETALL_SUCCESS: 'ASSET_CLASS_GETALL_SUCCESS',
  GETALL_FAILURE: 'ASSET_CLASS_GETALL_FAILURE',

  RESET: 'ASSET_CLASS_RESET',
  SERVICE: 'ASSET_CLASS_SERVICE',
};
